import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "prompt-wrapper" }
const _hoisted_2 = { class: "prompt-content" }
const _hoisted_3 = ["src"]

import { onMounted, ref, markRaw } from 'vue'
import type { Component } from 'vue'
import switchedAccount from './promptImages/switchedAccount.svg'
import notLogin from './promptImages/notLogin.svg'
import privateGroup from './promptImages/privateGroup.svg'

import loginPrivateMember from './promptComponents/loginPrivateMember.vue'
import loginPrivateNotMember from './promptComponents/loginPrivateNotMember.vue'
import loginPublicMember from './promptComponents/loginPublicMember.vue'
import loginPublicNotMember from './promptComponents/loginPublicNotMember.vue'
import notLoginPublic from './promptComponents/notLoginPublic.vue'
import notLoginPrivate from './promptComponents/notLoginPrivate.vue'
import multiAccountList from './promptComponents/multiAccountList.vue'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const imgUrl = ref('')
const componentKey = ref<Component>()
const { promptComponentType, onImgLoaded } = useAccountChange()

const handlePromptComponentType = () => {
  switch (promptComponentType.value) {
    case 'loginPublicMember':
      imgUrl.value = switchedAccount
      componentKey.value = markRaw(loginPublicMember)
      break
    case 'loginPublicNotMember':
      imgUrl.value = switchedAccount
      componentKey.value = markRaw(loginPublicNotMember)
      break
    case 'loginPrivateMember':
      imgUrl.value = switchedAccount
      componentKey.value = markRaw(loginPrivateMember)
      break
    case 'loginPrivateNotMember':
      imgUrl.value = privateGroup
      componentKey.value = markRaw(loginPrivateNotMember)
      break
    case 'multiAccountList':
      imgUrl.value = ''
      componentKey.value = markRaw(multiAccountList)
      break
    case 'notLoginPublic':
      imgUrl.value = notLogin
      componentKey.value = markRaw(notLoginPublic)
      break
    case 'notLoginPrivate':
      imgUrl.value = privateGroup
      componentKey.value = markRaw(notLoginPrivate)
      break
    default:
      break
  }
}
onMounted(() => {
  handlePromptComponentType()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (imgUrl.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: imgUrl.value,
            alt: "switchedAccount",
            class: "prompt-content__img",
            onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onImgLoaded) && _unref(onImgLoaded)(...args)))
          }, null, 40, _hoisted_3))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(componentKey.value)))
    ])
  ]))
}
}

})